import { CC_M, JOIST_W_M } from "../geometry/buildingDimensions";

/** Same axes as the built roof. These are positions, not a spacing capacity check. */
export function roofFramePositions(
	lengthM: number,
	joistWidthM = JOIST_W_M,
	spacingM = CC_M,
): number[] {
	if (
		![lengthM, joistWidthM, spacingM].every((n) => Number.isFinite(n) && n > 0)
	)
		return [];
	const run = Math.max(0, lengthM - joistWidthM);
	const intervals = Math.max(1, Math.ceil(run / spacingM));
	return Array.from(
		{ length: intervals + 1 },
		(_, i) => -run / 2 + (i * run) / intervals,
	);
}
